import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
var i = {
	16: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 16 16",
			fill: "none",
			...e,
			children: [
				/* @__PURE__ */ n("path", {
					d: "M4.5 1H9.79297L13.5 4.70703V14C13.5 14.4229 13.3946 14.6483 13.2715 14.7715C13.1483 14.8946 12.9229 15 12.5 15H4.5C4.07707 15 3.85168 14.8946 3.72852 14.7715C3.60536 14.6483 3.5 14.4229 3.5 14V2C3.5 1.57707 3.60536 1.35168 3.72852 1.22852C3.85168 1.10536 4.07707 1 4.5 1Z",
					fill: "#FCFBF8",
					stroke: "#DEDBD4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10 0.5V3.7C10 4.23333 10.2667 4.5 10.8 4.5H14L10 0.5Z",
					fill: "#EDEAE3"
				}),
				/* @__PURE__ */ n("rect", {
					x: 1,
					y: 8,
					width: 12.5,
					height: 6,
					rx: 1,
					fill: "#6D6963"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.40979 9.79775V9.22726H5.09765V9.79775H4.09569V12.5H3.41174V9.79775H2.40979Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.27909 9.22726L6.93907 10.3427H6.96463L7.62781 9.22726H8.40924L7.41048 10.8636L8.43161 12.5H7.6358L6.96463 11.383H6.93907L6.2679 12.5H5.47529L6.49961 10.8636L5.49446 9.22726H6.27909Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.81245 9.79775V9.22726H11.5003V9.79775H10.4983V12.5H9.8144V9.79775H8.81245Z",
					fill: "white"
				})
			]
		}),
		width: 16,
		height: 16
	},
	24: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 24 24",
			fill: "none",
			...e,
			children: [
				/* @__PURE__ */ n("path", {
					d: "M6 1.5H14.793L19.5 6.20703V21C19.5 21.5896 19.353 21.94 19.1465 22.1465C18.94 22.353 18.5896 22.5 18 22.5H6C5.41041 22.5 5.06001 22.353 4.85352 22.1465C4.64702 21.94 4.5 21.5896 4.5 21V3C4.5 2.41041 4.64702 2.06001 4.85352 1.85352C5.06001 1.64702 5.41041 1.5 6 1.5Z",
					fill: "#FCFBF8",
					stroke: "#DEDBD4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15 1V5C15 5.66667 15.3333 6 16 6H20L15 1Z",
					fill: "#EDEAE3"
				}),
				/* @__PURE__ */ n("rect", {
					x: 1,
					y: 12,
					width: 17,
					height: 8,
					rx: 1.5,
					fill: "#6D6963"
				}),
				/* @__PURE__ */ n("path", {
					d: "M3.21307 14.897V14.1364H6.79688V14.897H5.46094V18.5H4.54901V14.897H3.21307Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.37214 14.1364L9.25211 15.6236H9.2862L10.1704 14.1364H11.2123L9.88066 16.3182L11.2422 18.5H10.1811L9.2862 17.0106H9.25211L8.35722 18.5H7.3004L8.66617 16.3182L7.32597 14.1364H8.37214Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.7499 14.897V14.1364H15.3338V14.897H13.9978V18.5H13.0859V14.897H11.7499Z",
					fill: "white"
				})
			]
		}),
		width: 24,
		height: 24
	},
	40: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 40 40",
			fill: "none",
			...e,
			children: [
				/* @__PURE__ */ n("path", {
					d: "M10 2.5H24.793L32.5 10.207V35C32.5 35.9229 32.2696 36.5233 31.8965 36.8965C31.5233 37.2696 30.9229 37.5 30 37.5H10C9.07707 37.5 8.47668 37.2696 8.10352 36.8965C7.73036 36.5233 7.5 35.9229 7.5 35V5C7.5 4.07707 7.73036 3.47668 8.10352 3.10352C8.47668 2.73036 9.07707 2.5 10 2.5Z",
					fill: "#FCFBF8",
					stroke: "#DEDBD4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M25 2V9C25 9.66667 25.3333 10 26 10H33L25 2Z",
					fill: "#EDEAE3"
				}),
				/* @__PURE__ */ n("rect", {
					x: 3,
					y: 21,
					width: 25,
					height: 13,
					rx: 2,
					fill: "#6D6963"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.31961 25.5955V24.4546H11.6953V25.5955H9.69141V31H8.32352V25.5955H6.31961Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M14.0582 24.4546L15.3782 26.6854H15.4293L16.7556 24.4546H18.3185L16.321 27.7273L18.3632 31H16.7716L15.4293 28.766H15.3782L14.0358 31H12.4506L14.4993 27.7273L12.489 24.4546H14.0582Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M19.1249 25.5955V24.4546H24.5006V25.5955H22.4967V31H21.1288V25.5955H19.1249Z",
					fill: "white"
				})
			]
		}),
		width: 40,
		height: 40
	}
}, a = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: i[t],
	...r
});
//#endregion
export { a as FileTxtIcon };
